export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15086.6eb6efac.jpg";